export default {"src":"/_next/static/image/src/assets/footer/linkedin.da7451259abc1e9f0d99a1831d6da6ae.svg","height":24,"width":24};